import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import dayjs from 'dayjs';
export default {
  name: 'mng_admin',
  data: function data() {
    return {
      dayjs: dayjs,
      currentUser: localStorage.getItem('userId'),
      roleDatas: [],
      pageConfig: {
        editPageName: '管理员',
        addFunName: 'mngUserAddHasRoles',
        modifyFunName: 'mngUserModifyHasRoles',
        queryFunName: 'mngUserQuery',
        detailFunName: 'mngUserDetailHasRole',
        disableFunName: 'mngUserDisable',
        unDisableFunName: 'mngUserUnDisable',
        unLockFunName: 'mngUserUnLock',
        resetPasswordFunName: 'mngUserResetPassword',
        clearAuthFunName: 'mngUserClearAuth',
        roleAllQueryFunName: 'mngRoleQueryAll'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        category: 'admin',
        sortField: 'create_time'
      },
      formData: {
        id: null,
        account: null,
        nickname: null,
        image: null,
        category: 'admin',
        state: 'active',
        roleIds: [],
        userRoles: []
      },
      rules: {
        account: [{
          required: true,
          message: '管理员帐号不能为空',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '100px',
      emptyFormData: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.$api[this.pageConfig.roleAllQueryFunName]().then(function (res) {
      _this.roleDatas = res.data;
      _this.query();
    });
  },
  methods: {
    beforeCommand: function beforeCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command
      };
    },
    moreButton: function moreButton(command) {
      switch (command.command) {
        case 'unLock':
          // 解除锁定
          this.unLock(command.row.id);
          break;
        case 'disable':
          // 封禁用户
          this.disableUser(command.row.id);
          break;
        case 'unDisable':
          // 解封用户
          this.unDisableUser(command.row.id);
          break;
        case 'resetPassword':
          // 重置密码
          this.resetPassword(command.row.id);
          break;
        case 'clear':
          // 清理用户
          this.clearUser(command.row.id);
          break;
      }
    },
    unLock: function unLock(id) {
      var _this2 = this;
      this.$confirm('确定解锁当前用户吗').then(function () {
        _this2.$api[_this2.pageConfig.unLockFunName](id).then(function (res) {
          if (res.data) {
            _this2.$message.success('解锁成功');
            _this2.query();
          } else {
            _this2.$message.error('解锁失败');
          }
        });
      });
    },
    disableUser: function disableUser(id) {
      var _this3 = this;
      this.$confirm('确定封禁当前用户吗').then(function () {
        _this3.$api[_this3.pageConfig.disableFunName](id).then(function (res) {
          if (res.data) {
            _this3.$message.success('封禁成功');
            _this3.query();
          } else {
            _this3.$message.error('封禁失败');
          }
        });
      });
    },
    unDisableUser: function unDisableUser(id) {
      var _this4 = this;
      this.$confirm('确定解禁当前用户吗').then(function () {
        _this4.$api[_this4.pageConfig.unDisableFunName](id).then(function (res) {
          if (res.data) {
            _this4.$message.success('解禁成功');
            _this4.query();
          } else {
            _this4.$message.error('解禁失败');
          }
        });
      });
    },
    resetPassword: function resetPassword(id) {
      var _this5 = this;
      this.$confirm('确定重置当前用户密码吗').then(function () {
        _this5.$api[_this5.pageConfig.resetPasswordFunName](id).then(function (res) {
          if (res.data) {
            _this5.$message.success('重置成功');
            _this5.query();
          } else {
            _this5.$message.error('重置失败');
          }
        });
      });
    },
    clearUser: function clearUser(id) {
      var _this6 = this;
      this.$confirm('确定清除用户吗？用户清除后将不能恢复').then(function () {
        _this6.$confirm('请再次确认，是否清除当前用户？').then(function () {
          _this6.$confirm('请谨慎操作！！！最后确认是否清除当前用户？').then(function () {
            _this6.$api[_this6.pageConfig.clearAuthFunName](id).then(function (res) {
              if (res.data) {
                _this6.$message.success('清除成功');
                _this6.query();
              } else {
                _this6.$message.error('清除失败');
              }
            });
          });
        });
      });
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      paramData.roleIds = [];
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    upload: function upload(_ref) {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this7.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this7.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this7.formData.image = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    previewFile: function previewFile() {
      window.open(this.formData.image);
    },
    removeFile: function removeFile() {
      this.formData.image = '';
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(id) {
      var _this8 = this;
      this.$api[this.pageConfig.detailFunName](id, true).then(function (res) {
        _this8.initFormData(res.data);
        if (res.data.userRoles && res.data.userRoles.length > 0) {
          for (var i = 0; i < res.data.userRoles.length; i++) {
            _this8.formData.roleIds.push(res.data.userRoles[i].id);
          }
        }
        _this8.editDialogTitle = _this8.pageConfig.editPageName + '维护';
        _this8.editDialogShow = true;
      });
    },
    del: function del(id) {
      var _this9 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this9.$api[_this9.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this9.$message.success('删除成功');
            _this9.query();
          } else {
            _this9.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this10 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this10.tableData = res.data || [];
        _this10.totalCount = res.count;
        _this10.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this11 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this11.formData.id) {
            _this11.$api[_this11.pageConfig.modifyFunName](_this11.saveFormDataProcess(_this11.formData)).then(function (res) {
              if (res.data) {
                _this11.$message.success('编辑成功');
                _this11.initFormData(_this11.emptyFormData);
                _this11.editDialogShow = false;
                _this11.query();
              } else {
                _this11.$message.error('编辑失败');
              }
            });
          } else {
            _this11.$api[_this11.pageConfig.addFunName](_this11.saveFormDataProcess(_this11.formData)).then(function (res) {
              if (res.data) {
                _this11.$message.success('新增成功');
                _this11.initFormData(_this11.emptyFormData);
                _this11.editDialogShow = false;
                _this11.query();
              } else {
                _this11.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};